import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Save, Settings as SettingsIcon } from "lucide-react";

export default function AdminSettings() {
  const [minOrder, setMinOrder] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/settings");
        setMinOrder(data.min_order_amount ?? 0);
      } catch (e) {
        toast.error("Erreur chargement paramètres");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const val = Number(minOrder);
      if (Number.isNaN(val) || val < 0) {
        toast.error("Montant invalide");
        return;
      }
      await api.patch("/admin/settings", { min_order_amount: val });
      toast.success("Paramètres mis à jour");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erreur");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-settings-page" className="max-w-2xl">
      <p className="ff-overline">Configuration</p>
      <h1 className="font-serif text-3xl mt-2">Paramètres de la boutique</h1>

      {loading ? (
        <p className="mt-8 text-[#8A9A8E]">Chargement...</p>
      ) : (
        <form onSubmit={save} className="mt-8 ff-card p-6 space-y-6">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#4A5D4E]">
              Montant minimum de commande (CHF)
            </label>
            <p className="text-xs text-[#8A9A8E] mt-1 mb-2">
              Les clients ne pourront pas valider une commande dont le sous-total HT est inférieur à ce montant. Mettez 0 pour désactiver.
            </p>
            <div className="flex items-center gap-3">
              <span className="font-serif text-2xl text-[#2D6A4F]">CHF</span>
              <input
                type="number"
                min="0"
                step="1"
                value={minOrder}
                onChange={(e) => setMinOrder(e.target.value)}
                className="ff-input w-40 text-lg font-medium"
                data-testid="admin-min-order-input"
              />
            </div>
          </div>

          <div className="pt-4 border-t border-[#E5E3DC]">
            <button type="submit" disabled={saving} className="ff-btn-primary" data-testid="admin-settings-save">
              <Save className="w-4 h-4" /> {saving ? "Enregistrement..." : "Enregistrer"}
            </button>
          </div>
        </form>
      )}

      <div className="mt-8 ff-card p-6 bg-[#F2EFEB] border-[#E5E3DC]">
        <SettingsIcon className="w-5 h-5 text-[#2D6A4F]" />
        <h3 className="font-serif text-xl mt-3">À propos du minimum de commande</h3>
        <p className="text-sm text-[#4A5D4E] mt-2 leading-relaxed">
          Le minimum s'applique au <strong>sous-total HT</strong> (avant TVA et hors remise admin). Les commandes en dessous du seuil sont refusées avec un message clair pour le client.
        </p>
      </div>
    </div>
  );
}
